// src/api/ingestMonitor.js
import { apiGetJson } from "./http";

/* =========================
   Ingest Monitor API
========================= */
function qs(obj = {}) {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(obj)) {
    if (v == null) continue;
    p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : "";
}

// aceita: fn("created","year",0) OU fn({mode:"created",range:"year",offset:0})
function normalizeMR0(a, b, c, defaults) {
  if (a && typeof a === "object") {
    const { mode = defaults.mode, range = defaults.range, offset = defaults.offset } = a;
    return { mode, range, offset };
  }
  return {
    mode: a ?? defaults.mode,
    range: b ?? defaults.range,
    offset: c ?? defaults.offset,
  };
}


export async function getIngestSummary(a = "ingested", b = "day", c = 0) {
  const { mode, range, offset } = normalizeMR0(a, b, c, {
    mode: "ingested",
    range: "day",
    offset: 0,
  });
  return apiGetJson(`/api/ingest/summary${qs({ mode, range, offset })}`);
}

export async function getIngestTimeseries(a = "ingested", b = "day", c = 0) {
  const { mode, range, offset } = normalizeMR0(a, b, c, {
    mode: "ingested",
    range: "day",
    offset: 0,
  });
  return apiGetJson(`/api/ingest/timeseries${qs({ mode, range, offset })}`);
}


export async function getIngestLatest(limit = 50) {
  return apiGetJson(`/api/ingest/latest${qs({ limit })}`);
}

/**
 * ✅ heatmap geográfico (bins)
 */
export async function getIngestGeoHeatmap({
  mode = "ingested",
  range = "day",
  offset = 0,
  grid_m = 250,
  limit = 20000,
} = {}) {
  return apiGetJson(`/api/ingest/geo-heatmap${qs({ mode, range, offset, grid_m, limit })}`);
}

/**
 * ✅ NOVO: lista de drones no período (agregado por hardware_id)
 */
export async function getIngestDrones({
  mode = "ingested",
  range = "day",
  offset = 0,
  limit = 50,
} = {}) {
  return apiGetJson(`/api/ingest/drones${qs({ mode, range, offset, limit })}`);
}

// export async function getIngestDashboard() {
//   const r = await fetch(`/api/ingest/dashboard`, { credentials: "include" });
//   if (!r.ok) throw new Error(`dashboard_http_${r.status}`);
//   return r.json();
// }

export async function getIngestDashboard() {
  return apiGetJson("/api/ingest/dashboard");
}


export async function getPipeline(params = {}) {
  const q = params?.q ? String(params.q).trim() : "";
  const act_from = params?.act_from ? String(params.act_from).trim() : "";
  const act_to = params?.act_to ? String(params.act_to).trim() : "";
  const limit = params?.limit != null ? Number(params.limit) : 50;

  // usa seu helper qs() pra manter padrão
  return apiGetJson(
    `/api/ingest/pipeline${qs({
      q: q || null,
      act_from: act_from || null,
      act_to: act_to || null,
      limit: Number.isFinite(limit) ? limit : null,
    })}`
  );
}